<div class="fullImage" ><!-- [ngStyle]="{ background: backgroundImageSource }" -->
  <div
    class="background-column-container"
    fxLayout="column"
    fxLayoutAlign="center center"
    >
    <!--Passport Logo-->
    <div class="logo-container" role="presentation">
      <div class="logo-text-wrapper">
        @if (isDemo) {
          <img
            class="loginLogo"
            src="{{ logoImage }}"
            alt="Passport Logo"
            />
        }
        @if (!isDemo) {
          <div class="animationWrapper">
            <div class="square"><div class="slider"></div></div>
            <div class="logo"><div class="slider"></div></div>
            <div class="triangle"><div class="slider"></div></div>
          </div>
        }
      </div>
    </div>
    <!--General Card Space-->
    <div id="login-card" class="cardLogin">
      <router-outlet></router-outlet>
    </div>
    <!--Copyright Footer-->
    <mat-toolbar
      id="login-footer"
      class="copyrightFooter"
      fxLayout="column"
      fxLayoutAlign="center center"
      >
      <p class="copyrightText">
        All content &#169;
        <a
          class="copyrightLink"
          href="https://www.carnegielearning.com"
          target="_blank"
          >
          Carnegie Learning, LLC.</a
          >
          All rights reserved.
        </p>
        <div>
          <span class="buildText"
            ><i>Frontend {{ frontendBuildNumber }}</i></span
            >&nbsp;<span class="buildText"
            ><i>Api {{ apiBuildNumber }}</i></span
            >
          </div>
        </mat-toolbar>
      </div>
    </div>
